import * as actionTypes from '../actions/actionTypes';

import { updateObject } from '../../shared/utilities';

const initialState = {
    data: {},
    loading: false,
    error: null,
    isFetch: false,
    saved: false,
    saving: false,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.CONTACT_UPDATE_START:
            return updateObject(state, { saving: true, isFetch: false });

        case actionTypes.CONTACT_UPDATE_SUCCESS:
            const newData = updateObject(state.data, action.data);

            return updateObject(state, { saving: false, saved: true, isFetch: false, data: newData });

        case actionTypes.CONTACT_UPDATE_SUCCESS_END:
            return updateObject(state, { saved: false });

        case actionTypes.CONTACT_UPDATE_FAIL:
            return updateObject(state, { saving: false, isFetch: false, error: action.error });


        case actionTypes.CONTACT_FETCH_START:
            return updateObject(state, { loading: true, isFetch: false });

        case actionTypes.CONTACT_FETCH_SUCCESS:
            return updateObject(state, { loading: false, isFetch: false, data: action.data });

        case actionTypes.CONTACT_FETCH_FAIL:
            return updateObject(state, { loading: false, isFetch: false, error: action.error });


        default:
            return state;
    }
};


export default reducer;
